<template>
  <div class="login-wrap">
    <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box">
      <h3 class="login-title">选 图 <span>系</span> 统</h3>
      <el-form-item label-width="0" size="medium" prop="username" style="padding-bottom: 8px;">
        <el-input style="width: 295px" type="text" prefix-icon="el-icon-user" placeholder="请输入会员号或手机号" v-model="form.username" clearable/>
      </el-form-item>
      <el-form-item label-width="0" size="medium"  prop="password">
        <el-input style="width: 295px"  type="password"  prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="form.password" clearable/>
      </el-form-item>
      <div class="password-tips">
        <el-checkbox class="save-password" v-model="rmbPsdChecked">记住密码</el-checkbox>
        <div class="register" @click="toRegister">没有账号，点击注册会员!!</div>
      </div>
      <el-form-item label-width="0">
        <el-button style="width:100%;border-radius: 2.5px;" type="primary" v-on:click="onSubmit('loginForm')">登录</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>请正确输入账号或密码</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="pdf-dialog"
      :visible.sync="pdfDialogVisible"
      :show-close="false"
      width="80%"
      style="height: 90%;"
    >
      <div style="overflow-y: auto;">
        <pdf ref="pdf"
             :src="pdfUrl"
             :page="pageNum"
             :rotate="pageRotate"
             @progress="loadedRatio = $event"
             @page-loaded="pageLoaded($event)"
             @num-pages="pageTotalNum=$event"
             @error="pdfError($event)"
             @link-clicked="page = $event">
        </pdf>
      </div>
      <div style="position: sticky;bottom: 10px;background-color: #fff;">
        <div class="tools" style="display: flex;justify-content: center;align-items: center;">
          <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="prePage" class="mr10"> 上一页</el-button>
          <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="nextPage" class="mr10"> 下一页</el-button>
          <div class="page" style="margin-left: 10px">{{pageNum}}/{{pageTotalNum}} </div>
        </div>
<!--        <div style="text-align: left">-->
<!--          <el-checkbox  prop="checked" v-model="checked">已详阅并同意</el-checkbox>-->
<!--        </div>-->
        <div style="text-align: right">
         <el-button type="primary" @click="signContract">确定</el-button>
       </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    name: "Login",
    data() {
      return {
        form: {
          username: window.sessionStorage.name,
          password: ''
        },
        rmbPsdChecked: false,  //记住密码
        // 表单验证，需要在 el-form-item 元素中增加 prop 属性
        rules: {
          username: [
            {required: true, message: '账号不可为空', trigger: 'blur'},
          /*  { type: "string", min: 2, message: "账号不能小于2位", trigger: "blur" },
            { type: "string", max: 20, message: "账号不能大于20位", trigger: "blur" },*/
            {pattern: /^[_0-9a-zA-Z\u4E00-\u9FA5]+$/, message: '账号只能为中文、数字、字母、下划线', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不可为空', trigger: 'blur'},
          /*  { type: "string", min: 6, message: "密码不能小于6位", trigger: "blur" },
            { type: "string", max: 20, message: "密码不能大于20位", trigger: "blur" },*/
          ]
        },

        // 对话框显示和隐藏
        dialogVisible: false,

        pdfDialogVisible: false,
        // pdfUrl: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf",
        pdfUrl: '',
        pageNum: 1,
        pageTotalNum: 1,
        pageRotate: 0,
        // 加载进度
        loadedRatio: 0,
        curPageNum: 0,
        idx: -1,
        scale: 100, //放大系数
        checked: false
      }
    },
  /*  activated(){
      console.log(' this.$router.options.routes,this.rmbPsdChecked',this.$router.options.routes)
      this.rmbPsdChecked = window.sessionStorage.rmbPassword
      if(this.rmbPsdChecked){
        this.form.password =  window.sessionStorage.password;
      }
    },*/
    components: {
      pdf
    },
    mounted(){
      console.log(' this.$router.options.routes,this.window.sessionStorage.rmbPassword',window.sessionStorage.rmbPassword)
      this.rmbPsdChecked = window.sessionStorage.rmbPassword ? true : false;
      if(this.rmbPsdChecked){
        this.form.password =  window.sessionStorage.password;
      }
    },
    methods: {
      onSubmit(formName) {
        window.sessionStorage.name = this.form.username;
        if(this.rmbPsdChecked){
          window.sessionStorage.password = this.form.password;
        }
        // 为表单绑定验证功能
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('校验通过==')
            this.$http.post("/user/login", {
              // .post("/api/login/", {
              username: this.form.username,
              password: this.form.password
            })
              .then(res => {
                console.log('res====',res)
                console.log('resdata====',res.data)
                //  console.log("输出response.data", res.data);
                if (res.data.code === 'ok') {
                  console.log('resdatadata====',res.data.data)
                  window.sessionStorage.manageToken = res.data.data.token;
                  window.sessionStorage.userNameForShow = this.form.username;
                  window.sessionStorage.functionCodeList = res.data.data.functionCodeList;
                  window.sessionStorage.role = res.data.data.role;
                  window.localStorage.role = res.data.data.role;
                  window.sessionStorage.userName = res.data.data.name;
                  if(res.data.data.role == '7'){
                    this.queryContract();
                    // this.$router.push({ path: "/center" });
                  }else {
                    this.$router.push({ path: "/layout" });
                  }
                } else {
                  this.$message.error(res.data.data)
                }
              });

            //todo  mock
            // this.$router.push({ path: "/layout" });
          } else {
            // this.dialogVisible = true;
            return false;
          }
        });
      },
      queryContract(){
        this.$http.post(`http://quick9.shenzhuo.vip:22847/bookmenu/user/queryContract`, {

        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              const contractUrl = res.data.data && res.data.data.contractUrl;
              if(contractUrl){
                // this.pdfUrl = window.baseURL + '/images' + contractUrl;
                this.pdfUrl = contractUrl;
                this.pdfDialogVisible = true;
              }else{
                this.$router.push({ path: "/load" });
              }
            } else {
              // this.$message.error(res.data.data)
              this.$router.push({ path: "/load" });
            }
          });
      },
      signContract(){
        // if(!this.checked){
        //   this.$message.error('请详阅并同意协议');
        //   return
        // }
        this.$http.post(`/user/signContract`, {

        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              this.$router.push({ path: "/load" });
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      //去注册
      toRegister(){
        this.$router.push({ name: "Register" });
      },
      //点击登录校验弹框
      handleClose(){},
      // 上一页函数，
      prePage() {
        var page = this.pageNum
        page = page > 1 ? page - 1 : this.pageTotalNum
        this.pageNum = page
      },
      // 下一页函数
      nextPage() {
        var page = this.pageNum
        page = page < this.pageTotalNum ? page + 1 : 1
        this.pageNum = page
      },
      // 页面加载回调函数，其中e为当前页数
      pageLoaded(e) {
        this.curPageNum = e
      },
      // 其他的一些回调函数。
      pdfError(error) {
        console.error(error)
      },
      //放大
      scaleD() {
        this.scale += 5;
        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
        this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
      },
      //缩小
      scaleX(){
        if (this.scale == 100) {
          return;
        }
        this.scale += -5;
        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
        this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
      },
    },
    watch: {
      rmbPsdChecked(newVal){
        console.log(111111,newVal)
        if (newVal) {
          // window.sessionStorage.username =  this.form.username;
          window.sessionStorage.password = this.form.password;
          window.sessionStorage.rmbPassword = true;
          // localStorage.rmbPassword = true;
        } else {
          // localStorage.rmbPassword = false;
          window.sessionStorage.password = '';
          window.sessionStorage.rmbPassword = false;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .login-wrap {
    /*height: 100%;*/
    display: flex;
    justify-content: center;
    flex: 1;
    padding-top: 90px;
    background: url("~@assets/imgs/login-bg.png") no-repeat;
    background-size: cover;
  }
  .login-box {
    border: 1px solid #DCDFE6;
    /*width: 541px;*/
    /*margin: 180px auto;*/
    padding: 54px 125px 34px 125px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    /*box-shadow: 0 0 25px #909399;*/
    background-color: #fff;
    height: 358.5px;
    box-shadow: 0 3.5px 13.5px 0 rgba(133, 169, 231, 0.51);
    border-radius: 10px;
  }

  .login-title {
    /*text-align: center;
    margin: 0 auto 40px auto;
    color: #303133;*/
    font-family: DFHeiGB-W9;
    font-weight: normal;
    font-stretch: normal;
    /*line-height: 5.76rem;*/
    /*letter-spacing: 1.55rem;*/
    font-size: 26px;
    color: #666;
    padding-bottom: 33px;
    span {
      color: #317fff;
    }
  }
  .password-tips {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 58px;
    .save-password {
      display: flex;
      align-items: center;
      font-family: DFHeiGB-W5;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      color: #666;
      opacity: 0.6;
    }
    .register {
      font-family: DFHeiGB-W5;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      color: #317fff;
    }
  }
  .pdf-dialog {
    /deep/ .el-dialog__header {
      padding-top: 0;
    }
    /deep/ .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
